import { AccountUpdate, AccountWithUsers } from '@api/types';

export class AccountDetailsForm {
  name: string;
  phone_number: string;
  address_1: string;
  address_2: string;
  city: string;
  state: string;
  postal_code: string;

  constructor(accountUpdate: AccountWithUsers) {
    this.name = accountUpdate.name;
    this.phone_number = accountUpdate.phone_number;
    this.address_1 = accountUpdate.street1;
    this.address_2 = accountUpdate.street2;
    this.city = accountUpdate.city;
    this.state = accountUpdate.state;
    this.postal_code = accountUpdate.postal_code;
  }
}

export class AccountDetailUpdate implements AccountUpdate {
  name: string;
  phone_number: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  postal_code: string;

  constructor(formGroupValues: AccountDetailsForm) {
    this.name = formGroupValues.name;
    this.phone_number = formGroupValues.phone_number;
    this.street1 = formGroupValues.address_1;
    // can be null
    this.street2 = formGroupValues.address_2;
    this.city = formGroupValues.city;
    this.state = formGroupValues.state;
    this.postal_code = formGroupValues.postal_code;
  }
}
